import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import { all_routes } from "../router/all_routes";
import MiniProfileCard from "./components/MiniProfileCard";
import { useAuth } from "../auth/AuthProvider";
import styles from "./styles/SocialLayout.module.css";


interface SocialLayoutProps {
  title: string;
  children: React.ReactNode;
}

const SocialLayout: React.FC<SocialLayoutProps> = ({ title, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const currentPath = location.pathname;

  const breadcrumbMap: { [key: string]: string } = {
    [all_routes.feed]: "Feed",
    [all_routes.minhasPostagens]: "Minhas Postagens",
  };

  const secondBreadcrumbLabel =
    Object.keys(breadcrumbMap).find((path) => currentPath.includes(path))
      ? breadcrumbMap[
      Object.keys(breadcrumbMap).find((path) =>
        currentPath.includes(path)
      )!
      ]
      : "Rede Social";

  const breadcrumbs = [
    { label: "Início", link: "/", active: currentPath === "/" },
    { label: secondBreadcrumbLabel, active: true },
  ];

  // 👉 função para abrir o modal de registro/login
  const openRegisterModal = () => {
    const modalEl = document.getElementById("register-modal");
    if (modalEl) {
      const bootstrapModal = new (window as any).bootstrap.Modal(modalEl);
      bootstrapModal.show();
    }
  };

  // 👉 quando clicar no link de "Perfil / Minhas Postagens"
  const handleProfileClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!user) {
      // usuário não logado → abre modal
      openRegisterModal();
    } else {
      // logado → vai para a rota normalmente
      navigate(all_routes.minhasPostagens);
    }
  };

  return (
    <div>
      <Breadcrumb
        title={title}
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-01"
      />

      <div className="content">
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="row">
            {/* Sidebar */}
            <aside className="col-xl-3 col-lg-4 d-none d-lg-block">
              <div className={styles.sidebarContainer}>
                <div className={styles.miniProfileCardWrapper}>
                  <MiniProfileCard />
                </div>
                <h2 className="h5 fw-bold mb-4">Menu</h2>
                <ul className="list-unstyled">
                  <li>
                    <a href={all_routes.minhasPostagens} onClick={handleProfileClick}>
                      Perfil / Minhas postagens
                    </a>
                  </li>
                  <li>
                    <a href={all_routes.feed}>Feed</a>
                  </li>
                  <li>
                    <a href={all_routes.userFeedExplore}>Explorar</a>
                  </li>
                </ul>
              </div>
            </aside>

            {/* Conteúdo principal */}
            <main className="col-xl-9 col-lg-8">
              <div className="p-3 card shadow-sm">{children}</div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialLayout;